module.exports = __webpack_public_path__ + "img/Path-right-survol.8967bb48.svg";